<template>
    <breadCrumbs title="Form Wizard With Icon" main="Form Layout" title1="Form Wizard With Icon" />
          <div class="container-fluid text-start">
            <div class="row">
                <SimpleWizard/>
            </div>
          </div>
</template>
<script>
import SimpleWizard from "./SimpleWizard1.vue"
export default {
    components:{
        SimpleWizard
    }
}
</script>